import profileMessages from '@rhg/lang/messages/profile';
import { logger } from '@rhg/libs/logger';
import { TextField } from '@rhg/libs/material';
import { ColorMode } from '@rhg/libs/material/theme';
import { useRouter } from 'next/router';
import { useState } from 'react';
import { useIntl } from 'react-intl';

export type ThemeOption = ColorMode | 'unset';

export const SELECTED_THEME_KEY = 'SELECTED_THEME';

const options: ThemeOption[] = ['unset', 'light', 'dark'];

export default function ThemeSelector() {
    const { replace, pathname, query } = useRouter();
    const { formatMessage } = useIntl();

    const [selectedOption, setSelectedOption] = useState<ThemeOption>(
        // eslint-disable-next-line no-restricted-syntax
        (localStorage.getItem(SELECTED_THEME_KEY) as ThemeOption) ?? 'unset'
    );

    const handleThemeChanged = (option: ThemeOption) => {
        // eslint-disable-next-line no-restricted-syntax
        localStorage.setItem(SELECTED_THEME_KEY, option);

        setSelectedOption(option);

        // adding a query param to force the _app component to update used theme immediately without adding any global state
        replace({
            pathname,
            query: {
                ...query,
                theme: option,
            },
        }).catch((err) =>
            logger.error('Failed to apply theme query', {}, err as Error)
        );
    };

    return (
        <TextField
            select
            value={selectedOption}
            SelectProps={{ native: true }}
            label={formatMessage(profileMessages['profile.theme.label'])}
            onChange={(e) => handleThemeChanged(e.target.value as ThemeOption)}
        >
            {options.map((option) => (
                <option value={option} key={option}>
                    {formatMessage(profileMessages[`profile.theme.${option}`])}
                </option>
            ))}
        </TextField>
    );
}
